import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import LegendRateElement from './LegendRateElement';


function LegendRate() {
    return (
        <div className="legend-rate" style={{
            backgroundColor: "white",
            padding: "10px",
        }}>
            <LegendRateElement color="green" text="Dobry stan osiągnięty (GES)" />
            <LegendRateElement color="red" text="Dobry stan nieosiągnięty (subGES)" />
            <LegendRateElement color="#6b778a" text="Brak oceny" />
        </div >
    );
}

export default LegendRate;